import { isDefined } from '@hc-frontend/core-utils-validations';

import { formatAddress } from '../../helpers/format-address';
import { formatDependent } from '../../helpers/format-dependent';
import { formatHouseholdSize } from '../../helpers/format-household';
import { formatIncome } from '../../helpers/format-income';
import { formatMember } from '../../helpers/format-member';
import { UserLeadItem } from '../../molecules/user-lead-item/user-lead-item';
import type { UserLeadBannerProps } from './user-lead-banner.types';

export function UserLeadBanner({ lead }: UserLeadBannerProps) {
  const { applicant, spouse, children } = lead;

  return (
    <div className="hc-container-layout shadow-sm">
      <div className="flex flex-wrap items-stretch gap-x-24-24 gap-y-12-12 py-12-12">
        <UserLeadItem
          title={`Name${isDefined(applicant?.dateOfBirth) ? ', Age' : ''}`}
          content={formatMember(applicant)}
          id="name-age"
        />
        {spouse ? (
          <UserLeadItem
            title="Spouse"
            content={formatDependent(spouse)}
            id="spouse"
          />
        ) : null}
        {children?.map((child) => (
          <UserLeadItem
            key={`${child.firstName}-${child.lastName}`}
            title="Child"
            content={formatDependent(child)}
            id="child"
          />
        ))}
        <UserLeadItem
          title="Home Location"
          content={formatAddress(lead.location)}
          id="home-location"
        />
        <UserLeadItem
          title="Household Income"
          content={formatIncome(lead.householdIncome)}
          id="household-income"
        />
        {lead.householdSize && lead.householdSize > 1 && (
          <UserLeadItem
            title="Household Size"
            content={formatHouseholdSize(lead.householdSize)}
            id="household-size"
          />
        )}
      </div>
    </div>
  );
}
